var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	97049: {
		fallback: () => (() => (__webpack_require__(/*! @angular/common/http */ 46443))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=14.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	95692: {
		fallback: () => (() => (__webpack_require__(/*! @angular/common/http */ 46443))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	68302: {
		fallback: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0 || ^22.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/common",

	},
	57148: {
		fallback: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=13",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/common",

	},
	98179: {
		fallback: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=14.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/common",

	},
	24788: {
		fallback: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/common",

	},
	15199: {
		fallback: () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	51529: {
		fallback: () => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	24732: {
		fallback: () => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	42900: {
		fallback: () => (() => (__webpack_require__(/*! @angular/core */ 37580))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0 || ^22.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/core",

	},
	8728: {
		fallback: () => (() => (__webpack_require__(/*! @angular/core */ 37580))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/core",

	},
	96230: {
		fallback: () => (() => (__webpack_require__(/*! @angular/core */ 37580))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=13",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/core",

	},
	4514: {
		fallback: () => (() => (__webpack_require__(/*! @angular/core */ 37580))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/core",

	},
	48399: {
		fallback: () => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0 || ^22.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	35771: {
		fallback: () => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	10888: {
		fallback: () => (() => (__webpack_require__(/*! @angular/router */ 95072))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=13",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/router",

	},
	63999: {
		fallback: () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.5.3 || ^7.4.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	19736: {
		fallback: () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.5.3 || ^7.5.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	18855: {
		fallback: () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.2",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	30299: {
		fallback: () => (() => (__webpack_require__(/*! rxjs */ 80845))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.5.3 || ^7.4.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "rxjs",

	},
	3388: {
		fallback: () => (() => (__webpack_require__(/*! rxjs */ 80845))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.5.3 || ^7.5.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "rxjs",

	},
	80115: {
		fallback: () => (() => (__webpack_require__(/*! rxjs */ 80845))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.2",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "rxjs",

	},
	32991: {
		fallback: () => (() => (__webpack_require__(/*! @ngrx/store */ 81383))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@ngrx/store",

	},
	4248: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ngrx_store_ngrx_store-_aaef"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-state-store_snelstart_util-state-store"), __webpack_require__.e("default-webpack_sharing_consume_default_auth0_auth0-angular_auth0_auth0-angular"), __webpack_require__.e("default-webpack_sharing_consume_default_auth0_angular-jwt_auth0_angular-jwt"), __webpack_require__.e("default-node_modules_snelstart_util-events_fesm2022_snelstart-util-events_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_models-environment_snelstart_models-environment"), __webpack_require__.e("node_modules_snelstart_util_fesm2022_snelstart-util_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/util */ 57863))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util",

	},
	65794: {
		fallback: () => (() => (__webpack_require__(/*! @ngrx/store */ 81383))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@ngrx/store",

	},
	47339: {
		fallback: () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.2",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	49499: {
		fallback: () => (() => (__webpack_require__(/*! rxjs */ 80845))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.2",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "rxjs",

	},
	90280: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ngrx_store_ngrx_store-_aaef"), __webpack_require__.e("node_modules_snelstart_util-state-store_fesm2022_snelstart-util-state-store_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/util-state-store */ 72495))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-state-store",

	},
	74160: {
		fallback: () => (() => (__webpack_require__(/*! @angular/common/http */ 46443))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	45534: {
		fallback: () => (__webpack_require__.e("node_modules_snelstart_models-environment_fesm2022_snelstart-models-environment_mjs").then(() => (() => (__webpack_require__(/*! @snelstart/models-environment */ 50831))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/models-environment",

	},
	46029: {
		fallback: () => (() => (__webpack_require__(/*! @auth0/auth0-angular */ 37989))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~2.9.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@auth0/auth0-angular",

	},
	50150: {
		fallback: () => (() => (__webpack_require__(/*! @angular/router */ 95072))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/router",

	},
	74772: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("node_modules_snelstart_ui-icon_fesm2022_snelstart-ui-icon_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-icon */ 49175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-icon",

	},
	68994: {
		fallback: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/common",

	},
	91388: {
		fallback: () => (__webpack_require__.e("default-node_modules_snelstart_ui-badge_fesm2022_snelstart-ui-badge_mjs").then(() => (() => (__webpack_require__(/*! @snelstart/ui-badge */ 39319))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-badge",

	},
	48977: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_bootstrap_dist_js_bootstrap_esm_js"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-action-sheet_snelstart_ui-action-sheet"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util_snelstart_util"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-badge_snelstart_ui-badge"), __webpack_require__.e("default-node_modules_snelstart_ui-side-navigation_fesm2022_snelstart-ui-side-navigation_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-side-navigation */ 45347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-side-navigation",

	},
	97298: {
		fallback: () => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",

	},
	83188: {
		fallback: () => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/cdk/portal",

	},
	59844: {
		fallback: () => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/cdk/a11y",

	},
	46665: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-icon_snelstart_ui-icon"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-node_modules_bootstrap_dist_js_bootstrap_esm_js"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_snelstart_ui_fesm2022_snelstart-ui_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util_snelstart_util"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-loading_snelstart_ui-loading"), __webpack_require__.e("default-webpack_sharing_consume_default_auth0_auth0-angular_auth0_auth0-angular"), __webpack_require__.e("default-webpack_sharing_consume_default_auth0_angular-jwt_auth0_angular-jwt"), __webpack_require__.e("node_modules_snelstart_ui-button_fesm2022_snelstart-ui-button_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-button */ 29321))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-button",

	},
	67183: {
		fallback: () => (() => (__webpack_require__(/*! @popperjs/core */ 41280))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.11.8",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@popperjs/core",

	},
	74669: {
		fallback: () => (__webpack_require__.e("node_modules_snelstart_ui-loading_fesm2022_snelstart-ui-loading_mjs").then(() => (() => (__webpack_require__(/*! @snelstart/ui-loading */ 67935))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-loading",

	},
	55152: {
		fallback: () => (() => (__webpack_require__(/*! @auth0/angular-jwt */ 92389))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~5.2.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@auth0/angular-jwt",

	},
	80348: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-tag_snelstart_ui-tag"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-action-sheet_snelstart_ui-action-sheet"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay-_2789"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_scrolling_angular_cdk_scrolling"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util_snelstart_util"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-loading_snelstart_ui-loading"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal"), __webpack_require__.e("default-node_modules_snelstart_ui-dropdown_fesm2022_snelstart-ui-dropdown_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-dropdown */ 77911))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-dropdown",

	},
	2505: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_bootstrap_dist_js_bootstrap_esm_js"), __webpack_require__.e("default-webpack_sharing_consume_default_ngrx_store_ngrx_store-_aaef"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-state-store_snelstart_util-state-store"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-button_snelstart_ui-button"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-alert_snelstart_ui-alert"), __webpack_require__.e("default-node_modules_snelstart_ui-dialog_fesm2022_snelstart-ui-dialog_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-dialog */ 94869))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-dialog",

	},
	95052: {
		fallback: () => (() => (__webpack_require__(/*! @angular/forms */ 34456))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	74609: {
		fallback: () => (__webpack_require__.e("node_modules_snelstart_ui-tag_fesm2022_snelstart-ui-tag_mjs").then(() => (() => (__webpack_require__(/*! @snelstart/ui-tag */ 87191))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-tag",

	},
	92308: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-dropdown_snelstart_ui-dropdown"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-dialog_snelstart_ui-dialog"), __webpack_require__.e("default-node_modules_snelstart_ui-context-menu_fesm2022_snelstart-ui-context-menu_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-context-menu */ 47347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-context-menu",

	},
	4241: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ngrx_store_ngrx_store-_aaef"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util_snelstart_util"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-state-store_snelstart_util-state-store"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_snelstart_util-events_fesm2022_snelstart-util-events_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_models-environment_snelstart_models-environment"), __webpack_require__.e("default-node_modules_snelstart_util-address_fesm2022_snelstart-util-address_mjs-node_modules_-02c320"), __webpack_require__.e("default-node_modules_snelstart_domain-logic_fesm2022_snelstart-domain-logic_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/domain-logic */ 73467))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/domain-logic",

	},
	34812: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-icon_snelstart_ui-icon"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_bootstrap_dist_js_bootstrap_esm_js"), __webpack_require__.e("default-node_modules_snelstart_ui-toast_fesm2022_snelstart-ui-toast_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-toast */ 57103))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-toast",

	},
	1099: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-icon_snelstart_ui-icon"), __webpack_require__.e("default-node_modules_snelstart_ui-alert_fesm2022_snelstart-ui-alert_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-alert */ 68824))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-alert",

	},
	17097: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay-_2789"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal"), __webpack_require__.e("default-node_modules_snelstart_ui-action-sheet_fesm2022_snelstart-ui-action-sheet_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-action-sheet */ 11805))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-action-sheet",

	},
	36054: {
		fallback: () => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",

	},
	10755: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-icon_snelstart_ui-icon"), __webpack_require__.e("default-node_modules_bootstrap_dist_js_bootstrap_esm_js"), __webpack_require__.e("node_modules_snelstart_ui-tooltip-trigger_fesm2022_snelstart-ui-tooltip-trigger_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-tooltip-trigger */ 93715))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-tooltip-trigger",

	},
	34999: {
		fallback: () => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	8717: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-icon_snelstart_ui-icon"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-tag_snelstart_ui-tag"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-search-control_snelstart_ui-search-control"), __webpack_require__.e("default-node_modules_snelstart_ui-filter-container_fesm2022_snelstart-ui-filter-container_mjs-e3c8c2"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-loading_snelstart_ui-loading"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_domain-logic_snelstart_domain-logic"), __webpack_require__.e("default-node_modules_snelstart_ui-list_fesm2022_snelstart-ui-list_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-list */ 67909))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-list",

	},
	45483: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-icon_snelstart_ui-icon"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-node_modules_bootstrap_dist_js_bootstrap_esm_js"), __webpack_require__.e("default-webpack_sharing_consume_default_ngrx_store_ngrx_store-_aaef"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-tag_snelstart_ui-tag"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-context-menu_snelstart_ui-context-menu"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util_snelstart_util"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-state-store_snelstart_util-state-store"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-loading_snelstart_ui-loading"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-button_snelstart_ui-button"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_domain-logic_snelstart_domain-logic"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-dialog_snelstart_ui-dialog"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-toast_snelstart_ui-toast"), __webpack_require__.e("default-node_modules_snelstart_ui-details_fesm2022_snelstart-ui-details_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-details */ 89487))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-details",

	},
	33605: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-node_modules_snelstart_ui_fesm2022_snelstart-ui_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util_snelstart_util"), __webpack_require__.e("default-webpack_sharing_consume_default_auth0_auth0-angular_auth0_auth0-angular"), __webpack_require__.e("default-webpack_sharing_consume_default_auth0_angular-jwt_auth0_angular-jwt"), __webpack_require__.e("default-node_modules_snelstart_ui-search-control_fesm2022_snelstart-ui-search-control_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-search-control */ 59689))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-search-control",

	},
	49755: {
		fallback: () => (__webpack_require__.e("default-node_modules_snelstart_ui-panel_fesm2022_snelstart-ui-panel_mjs").then(() => (() => (__webpack_require__(/*! @snelstart/ui-panel */ 19591))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-panel",

	},
	81780: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-icon_snelstart_ui-icon"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-node_modules_bootstrap_dist_js_bootstrap_esm_js"), __webpack_require__.e("default-webpack_sharing_consume_default_ngrx_store_ngrx_store-_aaef"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-action-sheet_snelstart_ui-action-sheet"), __webpack_require__.e("default-node_modules_snelstart_ui_fesm2022_snelstart-ui_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-badge_snelstart_ui-badge"), __webpack_require__.e("default-node_modules_snelstart_util-address_fesm2022_snelstart-util-address_mjs-node_modules_-02c320"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-tooltip-trigger_snelstart_ui-tooltip-trigger"), __webpack_require__.e("default-node_modules_snelstart_ui-form-controls_fesm2022_snelstart-ui-form-controls_mjs")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-form-controls */ 59175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-form-controls",

	},
	7276: {
		fallback: () => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@angular/cdk/layout",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [97049,95692,68302,57148,98179,24788,15199,51529,24732,42900,8728,96230,4514,48399,35771,10888,63999,19736,18855,30299,3388,80115];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"polyfills": [
		97049,
		95692,
		68302,
		57148,
		98179,
		24788,
		15199,
		51529,
		24732,
		42900,
		8728,
		96230,
		4514,
		48399,
		35771,
		10888,
		63999,
		19736,
		18855,
		30299,
		3388,
		80115
	],
	"default-webpack_sharing_consume_default_ngrx_store_ngrx_store-_572f": [
		32991
	],
	"default-webpack_sharing_consume_default_snelstart_util_snelstart_util": [
		4248
	],
	"default-webpack_sharing_consume_default_ngrx_store_ngrx_store-_aaef": [
		65794
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		47339
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		49499
	],
	"default-webpack_sharing_consume_default_snelstart_util-state-store_snelstart_util-state-store": [
		90280
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		74160
	],
	"default-webpack_sharing_consume_default_snelstart_models-environment_snelstart_models-environment": [
		45534
	],
	"default-webpack_sharing_consume_default_auth0_auth0-angular_auth0_auth0-angular": [
		46029
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		50150
	],
	"default-webpack_sharing_consume_default_snelstart_ui-icon_snelstart_ui-icon": [
		74772
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		68994
	],
	"default-webpack_sharing_consume_default_snelstart_ui-badge_snelstart_ui-badge": [
		91388
	],
	"default-webpack_sharing_consume_default_snelstart_ui-side-navigation_snelstart_ui-side-navigation": [
		48977
	],
	"default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay-_2789": [
		97298
	],
	"default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal": [
		83188
	],
	"default-node_modules_snelstart_ui-action-sheet_fesm2022_snelstart-ui-action-sheet_mjs": [
		59844
	],
	"default-webpack_sharing_consume_default_snelstart_ui-button_snelstart_ui-button": [
		46665
	],
	"default-node_modules_bootstrap_dist_js_bootstrap_esm_js": [
		67183
	],
	"default-webpack_sharing_consume_default_snelstart_ui-loading_snelstart_ui-loading": [
		74669
	],
	"default-webpack_sharing_consume_default_auth0_angular-jwt_auth0_angular-jwt": [
		55152
	],
	"default-webpack_sharing_consume_default_snelstart_ui-dropdown_snelstart_ui-dropdown": [
		80348
	],
	"default-webpack_sharing_consume_default_snelstart_ui-dialog_snelstart_ui-dialog": [
		2505
	],
	"default-webpack_sharing_consume_default_angular_forms_angular_forms": [
		95052
	],
	"default-webpack_sharing_consume_default_snelstart_ui-tag_snelstart_ui-tag": [
		74609
	],
	"default-webpack_sharing_consume_default_snelstart_ui-context-menu_snelstart_ui-context-menu": [
		92308
	],
	"default-webpack_sharing_consume_default_snelstart_domain-logic_snelstart_domain-logic": [
		4241
	],
	"default-webpack_sharing_consume_default_snelstart_ui-toast_snelstart_ui-toast": [
		34812
	],
	"default-webpack_sharing_consume_default_snelstart_ui-alert_snelstart_ui-alert": [
		1099
	],
	"default-webpack_sharing_consume_default_snelstart_ui-action-sheet_snelstart_ui-action-sheet": [
		17097
	],
	"default-webpack_sharing_consume_default_angular_cdk_scrolling_angular_cdk_scrolling": [
		36054
	],
	"default-webpack_sharing_consume_default_snelstart_ui-tooltip-trigger_snelstart_ui-tooltip-trigger": [
		10755
	],
	"node_modules_snelstart_ui-icon_fesm2022_snelstart-ui-icon_mjs": [
		34999
	],
	"default-webpack_sharing_consume_default_snelstart_ui-list_snelstart_ui-list": [
		8717
	],
	"default-webpack_sharing_consume_default_snelstart_ui-details_snelstart_ui-details": [
		45483
	],
	"default-webpack_sharing_consume_default_snelstart_ui-search-control_snelstart_ui-search-control": [
		33605
	],
	"default-node_modules_snelstart_ui-table_fesm2022_snelstart-ui-table_mjs": [
		49755
	],
	"default-webpack_sharing_consume_default_snelstart_ui-form-controls_snelstart_ui-form-controls": [
		81780
	],
	"node_modules_snelstart_util_fesm2022_snelstart-util_mjs": [
		7276
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}